// extracted by mini-css-extract-plugin
export default {"grid":"ingredients-list_grid__hA9Xu"};